<template>
  <span :id="regionId" role="status" aria-live="polite" aria-atomic="true" class="sr-only">
    {{ statusMessage }}
  </span>
  <span role="alert" aria-live="polite" aria-atomic="true" class="sr-only">
    {{ politeMessage }}
  </span>
  <span role="alert" aria-live="assertive" aria-atomic="true" class="sr-only">
    {{ assertiveMessage }}
  </span>
</template>

<script setup>
import { computed } from 'vue'
import { useAccessibilityAlertStore } from 'vue_features/shared/store/composables/use_accessibility_alert_store'

defineProps({
  regionId: { type: String, default: 'accessibility-status-region' },
})

const { state } = useAccessibilityAlertStore()
const statusMessage = computed(() => (state.level === 'status' ? state.message : ''))
const politeMessage = computed(() => (state.level === 'polite' ? state.message : ''))
const assertiveMessage = computed(() => (state.level === 'assertive' ? state.message : ''))
</script>
